import { MapZoomButton } from "./MapZoomButton";
import { MeasureControl } from "./MeasureControl";

export class RigthActions {
  private _measureControl = new MeasureControl();
  private _zoomIn = new MapZoomButton("ph-plus", "Acercar", (m) => m.zoomIn());
  private _zoomOut = new MapZoomButton("ph-minus", "Acercar", (m) =>
    m.zoomOut(),
  );

  mount(
    element: HTMLElement,
    map: L.Map,
    onMeasureControlActivate: () => void,
  ) {
    this._measureControl.onActivate = onMeasureControlActivate;
    this._measureControl.init(element, map);

    this._zoomIn.init(element, map);
    this._zoomOut.init(element, map);
  }

  dispose() {
    this._measureControl.dispose();
    this._zoomIn.dispose();
    this._zoomOut.dispose();
  }

  getMeasureControlActive(): boolean {
    return this._measureControl.active;
  }

  /** Reenvía un click de un layer de lote como punto de medición (el lote lo
   *  llama cuando el control de medición está activo, en vez de seleccionar). */
  addMeasurePoint(latlng: L.LatLng): void {
    this._measureControl.addPoint(latlng);
  }
}
